// The encoder job template id is what will create an actual
// encoder job on the server side, this is a required constant.
export const ENCODER_JOB_TEMPLATE_ID = '6eba3d31-3efc-428e-a701-7ac2ad98b6a1';

// Define how long we wait before we poll job status again
export const JOB_POLL_DELAY = 5000;

// How many times to retry the request before rejecting
export const JOB_POLL_RETRY = 3;

// TODO: Each job currently has too many options for its' status.
//       The following are all the options that we are interested
//       in and the intermediary options are not something we are
//       interested in handling on the front-end. Data-service
//       needs to be updated to only emit the followinb job status:
//          1. Created
//          2. Processing
//          3. Completed
//          4. Failed
export const JobStatus = Object.freeze({
  Created: 'created',
  Pending: 'pending',
  Queued: 'queued',
  Processing: 'processing',
  Completed: 'completed',
  CompletedWithoutUpdate: 'completedWithoutUpdate',
  Failed: 'failed',
});
